export default __webpack_public_path__ + "static/media/1578.ad1264f6.png";